import React, { useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ajoutChariot, suppChariot } from "../actions/chariotActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCheck } from "@fortawesome/free-solid-svg-icons";
import "../ChariotMain.css"; // You'll need to create this CSS file
import { useNavigate } from "react-router-dom";
const ChariotMain = ({ route }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { chariotListe } = useSelector((state) => state.chariot);
  const { client } = useSelector((state) => state.client);

  const lien = "https://gestpro.globalsystempro.com";

  const handleIncreaseQuantity = useCallback(
    (item) => {
      dispatch(
        ajoutChariot(
          item.article,
          item.qty + 1,
          item.prix * (item.qty + 1),
          item.langue,
          item.source,
          item.prix,
          item.typ_mvt
        )
      );
    },
    [dispatch]
  );

  const handleDecreaseQuantity = useCallback(
    (item) => {
      if (item.qty > 1) {
        dispatch(
          ajoutChariot(
            item.article,
            item.qty - 1,
            item.prix * (item.qty - 1),
            item.langue,
            item.source,
            item.prix,
            item.typ_mvt
          )
        );
      }
    },
    [dispatch]
  );

  const handleRemoveItem = useCallback(
    (articleId) => {
      dispatch(suppChariot(articleId));
    },
    [dispatch]
  );

  const renderItem = useCallback(
    ({ item }) => (
      <div className="item-container">
        <img
          src={`${lien}${item.image}`}
          alt={item.nom}
          className="item-image"
        />
        <div className="item-details">
          <div className="item-name">{item.nom}</div>
          <div className="item-price">{item.prix_total.toFixed(3)}</div>
        </div>
        <div className="quantity-controls">
          <button
            onClick={() => handleIncreaseQuantity(item)}
            className="quantity-button"
          >
            <div className="quantity-button-text">+</div>
          </button>
          <div className="quantity-text">{item.qty}</div>
          <button
            onClick={() => handleDecreaseQuantity(item)}
            className="quantity-button"
            disabled={item.qty === 1}
          >
            <div className="quantity-button-text">-</div>
          </button>
        </div>
        <button
          onClick={() => handleRemoveItem(item.article)}
          className="remove-button"
        >
          <FontAwesomeIcon icon={faTrash} size="lg" color="red" />
        </button>
      </div>
    ),
    [handleIncreaseQuantity, handleDecreaseQuantity, handleRemoveItem]
  );

  const totalPrice = useMemo(
    () =>
      chariotListe.reduce((acc, item) => acc + item.prix_total, 0).toFixed(3),
    [chariotListe]
  );

  return (
    <div className="container">
      {chariotListe.length === 0 ? (
        <div className="empty-cart-container">
          <div className="empty-cart-text">Pas d'articles</div>
        </div>
      ) : (
        <>
          <button
            onClick={() => navigate("commandeInfo")}
            className="validate-button"
          >
            <div className="validate-button-text">
              Valider Commande{" "}
              <FontAwesomeIcon icon={faCheck} size="lg" color="green" />
            </div>
          </button>
          <div className="list-content">
            {chariotListe.map((item) => (
              <div key={item.article.toString()}>{renderItem({ item })}</div>
            ))}
          </div>
          <div className="total-container">
            <div className="total-text">Totale:</div>
            <div className="total-price">{totalPrice}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default ChariotMain;
